import { render } from "./MinimalStars.vue?vue&type=template&id=22ede627&scoped=true"
import script from "./MinimalStars.vue?vue&type=script&lang=js"
export * from "./MinimalStars.vue?vue&type=script&lang=js"

import "./MinimalStars.vue?vue&type=style&index=0&id=22ede627&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ede627"]])

export default __exports__
import QRating from 'quasar/src/components/rating/QRating.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QRating});
